/**
 * The two tabs both embedded directory widgets share.
 *
 * insurer-widget.js and widget.js each carried their own byte-identical
 * `manageTabs()`. core/components/Tabs.js replaced the strip itself; this
 * holds the part specific to these two widgets - the panel ids, which double
 * as the fragment an embed url can point at.
 */
export const SPECIALTY_TAB = 'specialty';
export const NAME_TAB = 'name';

/** `#name` in the embed url opens that tab, as the old hash handling did. */
export function tabFromHash(hash) {
    const id = (hash || '').replace(/^#/, '');
    return id === NAME_TAB || id === SPECIALTY_TAB ? id : null;
}
